import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 60,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 40,
    flexDirection: 'column',
    gap: 40,
    fontWeight: 400,
    fontSize: 10,
  },
  container: {
    flex: 1,
  },
  viewHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 40,
    height: 100,
  },
  viewInformation: {
    flexDirection: 'row',
    gap: 40,
  },
  information: {
    width: '50%',
  },
  titleTable: {
    color: '#333333',
    fontSize: 12,
    fontWeight: 'bold',
    borderBottomWidth: 1,
    borderColor: '#333333',
    paddingBottom: 5,
  },
  viewFooter: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  textFooter: {
    color: '#63667A',
    fontSize: 12,
  },
  tableWrap: {
    flexDirection: 'column',
    gap: 5,
  },

  total: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    width: 200,
  },

  textTotal: {
    width: 120,
    textAlign: 'right',
    fontSize: 10,
    color: '#333333',
    fontWeight: 'bold',
  },
  textSubTotal: {
    fontSize: 10,
    color: '#63667A',
  },
});
